import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidTypeValueError extends CodedError {
  static get errorName() {
    return errorCodes.invalidTypeValueError.code;
  }

  constructor(message: string = errorCodes.invalidTypeValueError.message) {
    super(message);
    this.code = errorCodes.invalidTypeValueError.code;
    this.message = `${message} ${errorCodes.invalidTypeValueError.code}`;
    this.name = errorCodes.invalidTypeValueError.name;
  }
}
